import { render, staticRenderFns } from "./AdditionalDrivers.vue?vue&type=template&id=8b6b20c4&"
import script from "./AdditionalDrivers.vue?vue&type=script&lang=js&"
export * from "./AdditionalDrivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports